module.exports = __webpack_public_path__ + "img/videos.6800f459.png";